<template>
  <div class="wa-balloon" aria-live="polite">
    <transition name="wa-fade">
      <div v-if="isOpen" class="wa-card" role="dialog" aria-label="Contato pelo WhatsApp">
        <div class="wa-card__header">
          <div>
            <p class="wa-card__title">Podemos ajudar?</p>
            <p class="wa-card__subtitle">Fale com a nossa equipe no WhatsApp.</p>
          </div>
          <button class="wa-card__close" @click="toggle(false)" aria-label="Fechar">
            &times;
          </button>
        </div>
        <a
          class="wa-card__cta"
          :href="whatsAppLink"
          target="_blank"
          rel="noopener"
        >
          Abrir conversa
        </a>
      </div>
    </transition>

    <button class="wa-toggle" @click="toggle()" aria-label="Abrir contato WhatsApp">
      <span class="wa-toggle__icon" aria-hidden="true">
        <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M16.05 4C9.95 4 5 8.95 5 15.03c0 2.36.7 4.55 2.01 6.46L5 28l6.7-1.95a11.1 11.1 0 004.35.88h.01c6.1 0 11.05-4.95 11.05-11.04C27.1 8.95 22.15 4 16.05 4zm5.99 15.55c-.26.73-1.54 1.37-2.15 1.46-.55.08-1.26.12-2.03-.13-.47-.15-1.08-.35-1.87-.69-3.3-1.43-5.45-4.75-5.62-4.98-.16-.23-1.34-1.78-1.34-3.4 0-1.63.84-2.43 1.14-2.77.3-.34.66-.43.88-.43.22 0 .44 0 .63.01.2.01.47-.08.74.56.26.65.89 2.23.96 2.4.08.17.13.37.02.6-.12.23-.18.38-.35.58-.17.2-.36.45-.52.6-.17.17-.35.35-.15.68.2.34.91 1.51 1.95 2.44 1.34 1.2 2.47 1.58 2.8 1.75.34.17.54.14.73-.08.2-.23.84-.98 1.07-1.32.23-.34.44-.28.74-.17.3.12 1.9.9 2.23 1.06.34.17.56.26.64.41.07.15.07.86-.2 1.6z"
            fill="currentColor"
          />
        </svg>
      </span>
      <span class="wa-toggle__label">WhatsApp</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "WhatsAppBalloon",
  props: {
    phone: {
      type: String,
      default: () => process.env.VUE_APP_WHATSAPP_PHONE || "5511918965087",
    },
    message: {
      type: String,
      default: () =>
        process.env.VUE_APP_WHATSAPP_MESSAGE || "Ola! Preciso de ajuda no VCVende.",
    },
    expandedOnLoad: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: this.expandedOnLoad,
    };
  },
  computed: {
    whatsAppLink() {
      const number = (this.phone || "").replace(/\D/g, "");
      const text = encodeURIComponent(this.message || "");
      return `https://wa.me/${number}?text=${text}`;
    },
  },
  methods: {
    toggle(force) {
      this.isOpen = typeof force === "boolean" ? force : !this.isOpen;
    },
  },
};
</script>

<style scoped>
.wa-balloon {
  position: fixed;
  right: 18px;
  bottom: 18px;
  z-index: 1200;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
}

.wa-card {
  width: 260px;
  background: #ffffff;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15);
  border-radius: 14px;
  padding: 12px 14px 14px 14px;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.wa-card__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 10px;
}

.wa-card__title {
  font-size: 16px;
  font-weight: 700;
  color: #128c7e;
  margin: 0;
}

.wa-card__subtitle {
  font-size: 13px;
  color: #2d3436;
  margin: 4px 0 0 0;
}

.wa-card__close {
  background: transparent;
  border: none;
  color: #6b6b6b;
  font-size: 18px;
  cursor: pointer;
  line-height: 1;
  padding: 0 4px;
}

.wa-card__cta {
  display: inline-block;
  width: 100%;
  text-align: center;
  padding: 10px 12px;
  background: linear-gradient(90deg, #25d366 0%, #128c7e 100%);
  color: #ffffff;
  border-radius: 10px;
  font-weight: 700;
  text-decoration: none;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.wa-card__cta:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 16px rgba(18, 140, 126, 0.25);
}

.wa-toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #25d366;
  color: #ffffff;
  border: none;
  border-radius: 999px;
  padding: 10px 12px;
  cursor: pointer;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.18);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.wa-toggle:hover {
  transform: translateY(-1px);
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.22);
}

.wa-toggle__icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #ffffff;
  color: #25d366;
}

.wa-toggle__icon svg {
  width: 20px;
  height: 20px;
}

.wa-toggle__label {
  font-weight: 700;
  font-size: 14px;
  line-height: 1.1;
}

.wa-fade-enter-active,
.wa-fade-leave-active {
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.wa-fade-enter,
.wa-fade-leave-to {
  opacity: 0;
  transform: translateY(6px);
}

@media (max-width: 768px) {
  .wa-balloon {
    right: 12px;
    bottom: 12px;
    gap: 6px;
  }

  .wa-card {
    width: 230px;
  }

  .wa-toggle {
    padding: 10px;
  }

  .wa-toggle__label {
    display: none;
  }
}
</style>
